module.exports = __webpack_public_path__ + "static/media/swichee_logo_2048p.feb4aa0a.png";